import { useLocation, useNavigate, useParams } from "react-router-dom";

export const convertTextToLowerCase = (textValue) => {
  return textValue.toLowerCase();
};

export const emailValidation = (emailValue) => {
  const regex = /\S+@\S+\.\S+/i;
  if (!emailValue || regex.test(emailValue) === false) {
    return false;
  }
  return true;
};

export const getCountryAstrowowId = (value) => {
  // Find the country by name
  let country = countries.find((country) => country.value === value);
  if (!country) {
    // Find the country by astrowowId
    country = countries.find((country) => country.astrowowId === value);
  }

  return country ? country.astrowowId : null;
};

export const getCountryLabel = (value) => {
  // Find the country by name
  let country = countries.find((country) => country.value === value);
  if (!country) {
    // Find the country by astrowowId
    country = countries.find((country) => country.astrowowId === value);
  }

  return country ? country.label : null;
};

export const getGender = (type) => {
  let genderName = "";
  if (type === "m") {
    genderName = "Male";
  } else if (type === "f") {
    genderName = "Female	";
  }

  return genderName;
};

export const getSign = (type) => {
  let signName = "";
  if (type === 1) {
    signName = "Aries";
  } else if (type === 2) {
    signName = "Taurus";
  } else if (type === 3) {
    signName = "Gemini";
  } else if (type === 4) {
    signName = "Cancer";
  } else if (type === 5) {
    signName = "Leo";
  } else if (type === 6) {
    signName = "Virgo";
  } else if (type === 7) {
    signName = "Libra";
  } else if (type === 8) {
    signName = "Scorpio";
  } else if (type === 9) {
    signName = "Sagittarius";
  } else if (type === 10) {
    signName = "Capricorn";
  } else if (type === 11) {
    signName = "Aquarius";
  } else if (type === 12) {
    signName = "Pisces";
  }

  return signName;
};

export const getStateAstrowowId = (value) => {
  const state = usStates.find((state) => state.value === value);
  return state ? state.astrowowId : null;
};

export const getStateLabel = (value) => {
  const state = usStates.find((state) => state.value === value);
  return state ? state.label : null;
};

export const withRouter = (Component) => {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }
  return ComponentWithRouterProp;
};

export const starSigns = [
  { label: "Please Select", value: 0 },
  { label: "Aries", value: 1 },
  { label: "Taurus", value: 2 },
  { label: "Gemini", value: 3 },
  { label: "Cancer", value: 4 },
  { label: "Leo", value: 5 },
  { label: "Virgo", value: 6 },
  { label: "Libra", value: 7 },
  { label: "Scorpio", value: 8 },
  { label: "Sagittarius", value: 9 },
  { label: "Capricorn", value: 10 },
  { label: "Aquarius", value: 11 },
  { label: "Pisces", value: 12 },
];

export const countries = [
  { label: "Please Select", value: "" },
  { label: "Afghanistan", value: "Afghanistan", astrowowId: "AA" },
  { label: "Åland Islands", value: "Åland Islands", astrowowId: null },
  { label: "Albania", value: "Albania", astrowowId: "AD" },
  { label: "Algeria", value: "Algeria", astrowowId: "AE" },
  { label: "American Samoa", value: "American Samoa", astrowowId: "IG" },
  { label: "Andorra", value: "Andorra", astrowowId: "AF" },
  { label: "Angola", value: "Angola", astrowowId: "AG" },
  { label: "Anguilla", value: "Anguilla", astrowowId: "AH" },
  { label: "Antarctica", value: "Antarctica", astrowowId: null },
  {
    label: "Antigua and Barbuda",
    value: "Antigua and Barbuda",
    astrowowId: "AI",
  },
  { label: "Argentina", value: "Argentina", astrowowId: "AJ" },
  { label: "Armenia", value: "Armenia", astrowowId: "AM" },
  { label: "Aruba", value: "Aruba", astrowowId: "KR" },
  { label: "Australia", value: "Australia", astrowowId: "AN" },
  { label: "Austria", value: "Austria", astrowowId: "AO" },
  { label: "Azerbaijan", value: "Azerbaijan", astrowowId: "AP" },
  { label: "Bahamas", value: "Bahamas", astrowowId: "AQ" },
  { label: "Bahrain", value: "Bahrain", astrowowId: "AR" },
  { label: "Bangladesh", value: "Bangladesh", astrowowId: "AS" },
  { label: "Barbados", value: "Barbados", astrowowId: "AT" },
  { label: "Belarus", value: "Belarus", astrowowId: "AU" },
  { label: "Belgium", value: "Belgium", astrowowId: "AV" },
  { label: "Belize", value: "Belize", astrowowId: "AW" },
  { label: "Benin", value: "Benin", astrowowId: "AX" },
  { label: "Bermuda", value: "Bermuda", astrowowId: "AY" },
  { label: "Bhutan", value: "Bhutan", astrowowId: "AZ" },
  { label: "Bolivia", value: "Bolivia", astrowowId: "BA" },
  {
    label: "Bonaire, Sint Eustatius and Saba",
    value: "Bonaire, Sint Eustatius and Saba",
    astrowowId: null,
  },
  {
    label: "Bosnia and Herzegovina",
    value: "Bosnia and Herzegovina",
    astrowowId: "BB",
  },
  { label: "Botswana", value: "Botswana", astrowowId: "BC" },
  { label: "Bouvet Island", value: "Bouvet Island", astrowowId: null },
  { label: "Brazil", value: "Brazil", astrowowId: "BD" },
  {
    label: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory",
    astrowowId: null,
  },
  { label: "Brunei Darussalam", value: "Brunei Darussalam", astrowowId: "BE" },
  { label: "Bulgaria", value: "Bulgaria", astrowowId: "BF" },
  { label: "Burkina Faso", value: "Burkina Faso", astrowowId: "BG" },
  { label: "Burundi", value: "Burundi", astrowowId: "BH" },
  { label: "Cambodia", value: "Cambodia", astrowowId: "BJ" },
  { label: "Cameroon", value: "Cameroon", astrowowId: "BK" },
  { label: "Canada", value: "Canada", astrowowId: "BL" },
  { label: "Cape Verde", value: "Cape Verde", astrowowId: "BM" },
  { label: "Cayman Islands", value: "Cayman Islands", astrowowId: "BN" },
  {
    label: "Central African Republic",
    value: "Central African Republic",
    astrowowId: "BO",
  },
  { label: "Chad", value: "Chad", astrowowId: "BP" },
  { label: "Chile", value: "Chile", astrowowId: "BQ" },
  { label: "China", value: "China", astrowowId: "BR" },
  { label: "Christmas Island", value: "Christmas Island", astrowowId: null },
  {
    label: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands",
    astrowowId: null,
  },
  { label: "Colombia", value: "Colombia", astrowowId: "BS" },
  { label: "Comoros", value: "Comoros", astrowowId: "BU" },
  { label: "Cook Islands", value: "Cook Islands", astrowowId: "BY" },
  { label: "Costa Rica", value: "Costa Rica", astrowowId: "BZ" },
  { label: "Croatia", value: "Croatia", astrowowId: "CA" },
  { label: "Cuba", value: "Cuba", astrowowId: "CB" },
  { label: "Curaçao", value: "Curaçao", astrowowId: null },
  { label: "Cyprus", value: "Cyprus", astrowowId: "CC" },
  { label: "Czech Republic", value: "Czech Republic", astrowowId: "CD" },
  {
    label: "Democratic Republic of the Congo",
    value: "Democratic Republic of the Congo",
    astrowowId: "BW",
  },
  { label: "Denmark", value: "Denmark", astrowowId: "CF" },
  { label: "Djibouti", value: "Djibouti", astrowowId: "CH" },
  { label: "Dominica", value: "Dominica", astrowowId: "CI" },
  {
    label: "Dominican Republic",
    value: "Dominican Republic",
    astrowowId: "CJ",
  },
  { label: "Ecuador", value: "Ecuador", astrowowId: "CL" },
  { label: "Egypt", value: "Egypt", astrowowId: "CM" },
  { label: "El Salvador", value: "El Salvador", astrowowId: "CN" },
  { label: "Equatorial Guinea", value: "Equatorial Guinea", astrowowId: "CO" },
  { label: "Eritrea", value: "Eritrea", astrowowId: "CP" },
  { label: "Estonia", value: "Estonia", astrowowId: "CQ" },
  { label: "Eswatini", value: "Eswatini", astrowowId: "JB" },
  { label: "Ethiopia", value: "Ethiopia", astrowowId: "CR" },
  { label: "Falkland Islands", value: "Falkland Islands", astrowowId: "CT" },
  { label: "Faroe Islands", value: "Faroe Islands", astrowowId: "CS" },
  { label: "Fiji", value: "Fiji", astrowowId: "CU" },
  { label: "Finland", value: "Finland", astrowowId: "CV" },
  { label: "France", value: "France", astrowowId: "CX" },
  { label: "French Guiana", value: "French Guiana", astrowowId: "CY" },
  { label: "French Polynesia", value: "French Polynesia", astrowowId: "CZ" },
  {
    label: "French Southern Territories",
    value: "French Southern Territories",
    astrowowId: null,
  },
  { label: "Gabon", value: "Gabon", astrowowId: "DA" },
  { label: "Gambia", value: "Gambia", astrowowId: "DB" },
  { label: "Georgia", value: "Georgia", astrowowId: "KS" },
  { label: "Germany", value: "Germany", astrowowId: "DD" },
  { label: "Ghana", value: "Ghana", astrowowId: "DE" },
  { label: "Gibraltar", value: "Gibraltar", astrowowId: "DF" },
  { label: "Greece", value: "Greece", astrowowId: "DG" },
  { label: "Greenland", value: "Greenland", astrowowId: "DH" },
  { label: "Grenada", value: "Grenada", astrowowId: "DI" },
  { label: "Guadeloupe", value: "Guadeloupe", astrowowId: "DJ" },
  { label: "Guam", value: "Guam", astrowowId: "DK" },
  { label: "Guatemala", value: "Guatemala", astrowowId: "DL" },
  { label: "Guernsey", value: "Guernsey", astrowowId: "DM" },
  { label: "Guinea", value: "Guinea", astrowowId: "DN" },
  { label: "Guinea-Bissau", value: "Guinea-Bissau", astrowowId: "DO" },
  { label: "Guyana", value: "Guyana", astrowowId: "DP" },
  { label: "Haiti", value: "Haiti", astrowowId: "DQ" },
  {
    label: "Heard Island and McDonald Islands",
    value: "Heard Island and McDonald Islands",
    astrowowId: null,
  },
  { label: "Honduras", value: "Honduras", astrowowId: "DS" },
  { label: "Hong Kong", value: "Hong Kong", astrowowId: null },
  { label: "Hungary", value: "Hungary", astrowowId: "DT" },
  { label: "Iceland", value: "Iceland", astrowowId: "DU" },
  { label: "India", value: "India", astrowowId: "DX" },
  { label: "Indonesia", value: "Indonesia", astrowowId: "DZ" },
  { label: "Iran", value: "Iran", astrowowId: "EB" },
  { label: "Iraq", value: "Iraq", astrowowId: "EC" },
  { label: "Ireland", value: "Ireland", astrowowId: "ED" },
  { label: "Isle of Man", value: "Isle of Man", astrowowId: "FM" },
  { label: "Israel", value: "Israel", astrowowId: "EE" },
  { label: "Italy", value: "Italy", astrowowId: "EF" },
  { label: "Ivory Coast", value: "Ivory Coast", astrowowId: "EG" },
  { label: "Jamaica", value: "Jamaica", astrowowId: "EH" },
  { label: "Japan", value: "Japan", astrowowId: "EI" },
  { label: "Jersey", value: "Jersey", astrowowId: "EJ" },
  { label: "Jordan", value: "Jordan", astrowowId: "EK" },
  { label: "Kazakhstan", value: "Kazakhstan", astrowowId: "EM" },
  { label: "Kenya", value: "Kenya", astrowowId: "EO" },
  { label: "Kiribati", value: "Kiribati", astrowowId: "EP" },
  { label: "Kuwait", value: "Kuwait", astrowowId: "ES" },
  { label: "Kyrgyzstan", value: "Kyrgyzstan", astrowowId: "ET" },
  { label: "Laos", value: "Laos", astrowowId: "EU" },
  { label: "Latvia", value: "Latvia", astrowowId: "EV" },
  { label: "Lebanon", value: "Lebanon", astrowowId: "EW" },
  { label: "Lesotho", value: "Lesotho", astrowowId: "EX" },
  { label: "Liberia", value: "Liberia", astrowowId: "EY" },
  { label: "Libya", value: "Libya", astrowowId: "EZ" },
  { label: "Liechtenstein", value: "Liechtenstein", astrowowId: "FA" },
  { label: "Lithuania", value: "Lithuania", astrowowId: "FB" },
  { label: "Luxembourg", value: "Luxembourg", astrowowId: "FD" },
  { label: "Macao", value: "Macao", astrowowId: null },
  { label: "Madagascar", value: "Madagascar", astrowowId: "FF" },
  { label: "Malawi", value: "Malawi", astrowowId: "FH" },
  { label: "Malaysia", value: "Malaysia", astrowowId: "FI" },
  { label: "Maldives", value: "Maldives", astrowowId: "FJ" },
  { label: "Mali", value: "Mali", astrowowId: "FK" },
  { label: "Malta", value: "Malta", astrowowId: "FL" },
  { label: "Marshall Islands", value: "Marshall Islands", astrowowId: "FN" },
  { label: "Martinique", value: "Martinique", astrowowId: "FO" },
  { label: "Mauritania", value: "Mauritania", astrowowId: "FR" },
  { label: "Mauritius", value: "Mauritius", astrowowId: "FS" },
  { label: "Mayotte", value: "Mayotte", astrowowId: "FT" },
  { label: "Mexico", value: "Mexico", astrowowId: "FU" },
  { label: "Micronesia", value: "Micronesia", astrowowId: "FW" },
  { label: "Moldova", value: "Moldova", astrowowId: "GB" },
  { label: "Monaco", value: "Monaco", astrowowId: "GC" },
  { label: "Mongolia", value: "Mongolia", astrowowId: "GD" },
  { label: "Montenegro", value: "Montenegro", astrowowId: "KU" },
  { label: "Montserrat", value: "Montserrat", astrowowId: "GF" },
  { label: "Morocco", value: "Morocco", astrowowId: "GG" },
  { label: "Mozambique", value: "Mozambique", astrowowId: "GH" },
  { label: "Myanmar", value: "Myanmar", astrowowId: "GI" },
  { label: "Namibia", value: "Namibia", astrowowId: "GJ" },
  { label: "Nauru", value: "Nauru", astrowowId: "GK" },
  { label: "Nepal", value: "Nepal", astrowowId: "GM" },
  { label: "Netherlands", value: "Netherlands", astrowowId: "GN" },
  { label: "New Caledonia", value: "New Caledonia", astrowowId: "GQ" },
  { label: "New Zealand", value: "New Zealand", astrowowId: "GV" },
  { label: "Nicaragua", value: "Nicaragua", astrowowId: "GW" },
  { label: "Niger", value: "Niger", astrowowId: "GX" },
  { label: "Nigeria", value: "Nigeria", astrowowId: "GY" },
  { label: "Niue", value: "Niue", astrowowId: "GZ" },
  { label: "Norfolk Island", value: "Norfolk Island", astrowowId: "HA" },
  { label: "North Korea", value: "North Korea", astrowowId: "EQ" },
  { label: "North Macedonia", value: "North Macedonia", astrowowId: "FE" },
  {
    label: "Northern Mariana Islands",
    value: "Northern Mariana Islands",
    astrowowId: "HD",
  },
  { label: "Norway", value: "Norway", astrowowId: "HE" },
  { label: "Oman", value: "Oman", astrowowId: "HH" },
  { label: "Pakistan", value: "Pakistan", astrowowId: "HJ" },
  { label: "Palau", value: "Palau", astrowowId: "HK" },
  {
    label: "Palestinian Territory",
    value: "Palestinian Territory",
    astrowowId: null,
  },
  { label: "Panama", value: "Panama", astrowowId: "HL" },
  { label: "Papua New Guinea", value: "Papua New Guinea", astrowowId: "HM" },
  { label: "Paraguay", value: "Paraguay", astrowowId: "HN" },
  { label: "Peru", value: "Peru", astrowowId: "HP" },
  { label: "Philippines", value: "Philippines", astrowowId: "HQ" },
  { label: "Pitcairn", value: "Pitcairn", astrowowId: "HR" },
  { label: "Poland", value: "Poland", astrowowId: "HS" },
  { label: "Portugal", value: "Portugal", astrowowId: "HT" },
  { label: "Puerto Rico", value: "Puerto Rico", astrowowId: "HU" },
  { label: "Qatar", value: "Qatar", astrowowId: "HV" },
  { label: "Réunion", value: "Réunion", astrowowId: "HW" },
  {
    label: "Republic of the Congo",
    value: "Republic of the Congo",
    astrowowId: "BV",
  },
  { label: "Romania", value: "Romania", astrowowId: "HY" },
  { label: "Russia", value: "Russia", astrowowId: "HZ" },
  { label: "Rwanda", value: "Rwanda", astrowowId: "IA" },
  {
    label: "São Tomé and Príncipe",
    value: "São Tomé and Príncipe",
    astrowowId: "IJ",
  },
  { label: "Saint Barthélemy", value: "Saint Barthélemy", astrowowId: null },
  { label: "Saint Helena", value: "Saint Helena", astrowowId: "IB" },
  {
    label: "Saint Kitts and Nevis",
    value: "Saint Kitts and Nevis",
    astrowowId: "IC",
  },
  { label: "Saint Lucia", value: "Saint Lucia", astrowowId: "ID" },
  {
    label: "Saint Martin (Dutch part)",
    value: "Saint Martin (Dutch part)",
    astrowowId: "GO",
  },
  {
    label: "Saint Martin (French part)",
    value: "Saint Martin (French part)",
    astrowowId: "GO",
  },
  {
    label: "Saint Pierre and Miquelon",
    value: "Saint Pierre and Miquelon",
    astrowowId: "IE",
  },
  {
    label: "Saint Vincent and the Grenadines",
    value: "Saint Vincent and the Grenadines",
    astrowowId: "IF",
  },
  { label: "Samoa", value: "Samoa", astrowowId: "IH" },
  { label: "San Marino", value: "San Marino", astrowowId: "II" },
  { label: "Saudi Arabia", value: "Saudi Arabia", astrowowId: "IK" },
  { label: "Senegal", value: "Senegal", astrowowId: "IL" },
  { label: "Serbia", value: "Serbia", astrowowId: "KW" },
  { label: "Seychelles", value: "Seychelles", astrowowId: "IM" },
  { label: "Sierra Leone", value: "Sierra Leone", astrowowId: "IN" },
  { label: "Singapore", value: "Singapore", astrowowId: "IO" },
  { label: "Slovakia", value: "Slovakia", astrowowId: "IP" },
  { label: "Slovenia", value: "Slovenia", astrowowId: "IQ" },
  { label: "Solomon Islands", value: "Solomon Islands", astrowowId: "IR" },
  { label: "Somalia", value: "Somalia", astrowowId: "IS" },
  { label: "South Africa", value: "South Africa", astrowowId: "IT" },
  {
    label: "South Georgia and the South Sandwich Islands",
    value: "South Georgia and the South Sandwich Islands",
    astrowowId: "IW",
  },
  { label: "South Korea", value: "South Korea", astrowowId: "ER" },
  { label: "South Sudan", value: "South Sudan", astrowowId: "KV" },
  { label: "Spain", value: "Spain", astrowowId: "IX" },
  { label: "Sri Lanka", value: "Sri Lanka", astrowowId: "IY" },
  { label: "Sudan", value: "Sudan", astrowowId: "IZ" },
  { label: "Suriname", value: "Suriname", astrowowId: "JA" },
  {
    label: "Svalbard and Jan Mayen",
    value: "Svalbard and Jan Mayen",
    astrowowId: null,
  },
  { label: "Sweden", value: "Sweden", astrowowId: "JC" },
  { label: "Switzerland", value: "Switzerland", astrowowId: "JD" },
  { label: "Syria", value: "Syria", astrowowId: "JE" },
  { label: "Taiwan", value: "Taiwan", astrowowId: "JF" },
  { label: "Tajikistan", value: "Tajikistan", astrowowId: "JG" },
  { label: "Tanzania", value: "Tanzania", astrowowId: "JH" },
  { label: "Thailand", value: "Thailand", astrowowId: "JK" },
  { label: "Timor-Leste", value: "Timor-Leste", astrowowId: "CK" },
  { label: "Togo", value: "Togo", astrowowId: "JL" },
  { label: "Tokelau", value: "Tokelau", astrowowId: "JM" },
  { label: "Tonga", value: "Tonga", astrowowId: "JN" },
  {
    label: "Trinidad and Tobago",
    value: "Trinidad and Tobago",
    astrowowId: "JO",
  },
  { label: "Tunisia", value: "Tunisia", astrowowId: "JP" },
  { label: "Turkey", value: "Turkey", astrowowId: "JQ" },
  { label: "Turkmenistan", value: "Turkmenistan", astrowowId: "JR" },
  {
    label: "Turks and Caicos Islands",
    value: "Turks and Caicos Islands",
    astrowowId: "JS",
  },
  { label: "Tuvalu", value: "Tuvalu", astrowowId: "JT" },
  { label: "Uganda", value: "Uganda", astrowowId: "JU" },
  { label: "Ukraine", value: "Ukraine", astrowowId: "JV" },
  {
    label: "United Arab Emirates",
    value: "United Arab Emirates",
    astrowowId: "JW",
  },
  { label: "United Kingdom", value: "United Kingdom", astrowowId: "JX" },
  { label: "United States", value: "United States", astrowowId: null },
  {
    label: "United States Minor Outlying Islands",
    value: "United States Minor Outlying Islands",
    astrowowId: "FX",
  },
  { label: "Uruguay", value: "Uruguay", astrowowId: "JY" },
  { label: "Uzbekistan", value: "Uzbekistan", astrowowId: "KA" },
  { label: "Vanuatu", value: "Vanuatu", astrowowId: "KB" },
  { label: "Vatican", value: "Vatican", astrowowId: null },
  { label: "Venezuela", value: "Venezuela", astrowowId: "KC" },
  { label: "Vietnam", value: "Vietnam", astrowowId: "KE" },
  {
    label: "Virgin Islands (British)",
    value: "Virgin Islands (British)",
    astrowowId: "KF",
  },
  {
    label: "Virgin Islands (US)",
    value: "Virgin Islands (US)",
    astrowowId: "KF",
  },
  { label: "Wallis and Futuna", value: "Wallis and Futuna", astrowowId: "KI" },
  { label: "Western Sahara", value: "Western Sahara", astrowowId: null },
  { label: "Yemen", value: "Yemen", astrowowId: "KN" },
  { label: "Zambia", value: "Zambia", astrowowId: "KP" },
  { label: "Zimbabwe", value: "Zimbabwe", astrowowId: "KQ" },
];

export const usStates = [
  { label: "Please Select", value: "", astrowowId: null },
  { label: "Alabama", value: "Alabama", astrowowId: "AB" },
  { label: "Alaska", value: "Alaska", astrowowId: "AC" },
  { label: "Arizona", value: "Arizona", astrowowId: "AK" },
  { label: "Arkansas", value: "Arkansas", astrowowId: "AL" },
  { label: "California", value: "California", astrowowId: "BI" },
  { label: "Colorado", value: "Colorado", astrowowId: "BT" },
  { label: "Connecticut", value: "Connecticut", astrowowId: "BX" },
  { label: "Delaware", value: "Delaware", astrowowId: "CE" },
  { label: "Dist of Columbia", value: "Dist of Columbia", astrowowId: "CG" },
  { label: "Florida", value: "Florida", astrowowId: "CW" },
  { label: "Georgia", value: "Georgia", astrowowId: "DC" },
  { label: "Hawaii", value: "Hawaii", astrowowId: "DR" },
  { label: "Idaho", value: "Idaho", astrowowId: "DV" },
  { label: "Illinois", value: "Illinois", astrowowId: "DW" },
  { label: "Indiana", value: "Indiana", astrowowId: "DY" },
  { label: "Iowa", value: "Iowa", astrowowId: "EA" },
  { label: "Kansas", value: "Kansas", astrowowId: "EL" },
  { label: "Kentucky", value: "Kentucky", astrowowId: "EN" },
  { label: "Louisiana", value: "Louisiana", astrowowId: "FC" },
  { label: "Maine", value: "Maine", astrowowId: "FG" },
  { label: "Maryland", value: "Maryland", astrowowId: "FP" },
  { label: "Massachusetts", value: "Massachusetts", astrowowId: "FQ" },
  { label: "Michigan", value: "Michigan", astrowowId: "FV" },
  { label: "Minnesota", value: "Minnesota", astrowowId: "FY" },
  { label: "Mississippi", value: "Mississippi", astrowowId: "FZ" },
  { label: "Missouri", value: "Missouri", astrowowId: "GA" },
  { label: "Montana", value: "Montana", astrowowId: "GE" },
  { label: "Nebraska", value: "Nebraska", astrowowId: "GL" },
  { label: "Nevada", value: "Nevada", astrowowId: "GP" },
  { label: "New Hampshire", value: "New Hampshire", astrowowId: "GR" },
  { label: "New Jersey", value: "New Jersey", astrowowId: "GS" },
  { label: "New Mexico", value: "New Mexico", astrowowId: "GT" },
  { label: "New York", value: "New York", astrowowId: "GU" },
  { label: "North Carolina", value: "North Carolina", astrowowId: "HB" },
  { label: "North Dakota", value: "North Dakota", astrowowId: "HC" },
  { label: "Ohio", value: "Ohio", astrowowId: "HF" },
  { label: "Oklahoma", value: "Oklahoma", astrowowId: "HG" },
  { label: "Oregon", value: "Oregon", astrowowId: "HI" },
  { label: "Pennsylvania", value: "Pennsylvania", astrowowId: "HO" },
  { label: "Rhode Island", value: "Rhode Island", astrowowId: "HX" },
  { label: "South Carolina", value: "South Carolina", astrowowId: "IU" },
  { label: "South Dakota", value: "South Dakota", astrowowId: "IV" },
  { label: "Tennessee", value: "Tennessee", astrowowId: "JI" },
  { label: "Texas", value: "Texas", astrowowId: "JJ" },
  { label: "Utah", value: "Utah", astrowowId: "JZ" },
  { label: "Vermont", value: "Vermont", astrowowId: "KD" },
  { label: "Virginia", value: "Virginia", astrowowId: "KG" },
  { label: "Washington", value: "Washington", astrowowId: "KJ" },
  { label: "West Virginia", value: "West Virginia", astrowowId: "KK" },
  { label: "Wisconsin", value: "Wisconsin", astrowowId: "KL" },
  { label: "Wyoming", value: "Wyoming", astrowowId: "KM" },
];

export const reportTypes = [
  { label: "DIG - Daily Influence Guide", value: 3 },
  { label: "Discontinued - EYF LCAG 2018/2023 (12 months)", value: 5 },
  { label: "EYF - Essential Year Forecast (3 months)", value: 6 },
  { label: "EYF - Essential Year Forecast (6 months)", value: 7 },
  { label: "EYF - Essential Year Forecast (12 months)", value: 8 },
  { label: "EYF - Essential Year Forecast (Year)", value: 4 },
  { label: "LCAG - Life Changing Astrology Guide", value: 2 },
  { label: "PDG - Personal Discovery Guide", value: 9 },
  { label: "PP - Personality Profile", value: 1 },
  { label: "TPG - Transit Period Guide (3 months)", value: 10 },
  { label: "TPG - Transit Period Guide (6 months)", value: 11 },
  { label: "TPG - Transit Period Guide (12 months)", value: 12 },
];

export const calculateAge = (birthday) => {
  //milliseconds in a year 1000*24*60*60*365.24 = 31556736000;
  let today = new Date(),
    dob = new Date(birthday),
    //difference in milliseconds
    diff = today.getTime() - dob.getTime(),
    //convert milliseconds into years
    years = Math.floor(diff / 31556736000),
    //1 day has 86400000 milliseconds
    days_diff = Math.floor((diff % 31556736000) / 86400000),
    //1 month has 30.4167 days
    months = Math.floor(days_diff / 30.4167),
    days = Math.floor(days_diff % 30.4167);

  const age = {
    years: years,
    months: months,
    days: days,
  };
  return age;
};

export const numerologyReportTypes = [
  { label: "Please Select", value: "" },
  { label: "Life Path", value: 1 },
  { label: "One Year", value: 2 },
];

export const monthDropdown = [
  { label: "Month", value: "" },
  { label: "January", value: 1 },
  { label: "Febuary", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const searchTypes = [
  { label: "By Customer Id", value: "customerId" },
  { label: "By Order ID", value: "orderId" },
];
